import { render, staticRenderFns } from "./PhoneRegister.vue?vue&type=template&id=1799dbdd&scoped=true&"
import script from "./PhoneRegister.vue?vue&type=script&lang=js&"
export * from "./PhoneRegister.vue?vue&type=script&lang=js&"
import style0 from "./PhoneRegister.vue?vue&type=style&index=0&id=1799dbdd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1799dbdd",
  null
  
)

export default component.exports